import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EtaComponent } from './eta.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  imports: [CommonModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule],
  exports: [EtaComponent],
  declarations: [EtaComponent]
})
export class EtaModule {}
